import { render, staticRenderFns } from "./MfaOtpScreen.vue?vue&type=template&id=5b9ca308&scoped=true"
import script from "./MfaOtpScreen.vue?vue&type=script&lang=js"
export * from "./MfaOtpScreen.vue?vue&type=script&lang=js"
import style0 from "./MfaOtpScreen.vue?vue&type=style&index=0&id=5b9ca308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ca308",
  null
  
)

export default component.exports